module.exports = __webpack_public_path__ + "static/media/cw2.ea27b524.png";